import { buildDocumentVersionEndpointPath } from '@cs-cms/api-client';
import {
  CpsDocumentMetadata,
  CpsField,
  DocumentVersionResponse,
  MainDocContentTypeResponse
} from '@cs-cms/types';

export interface DisplayableMetadataEntry {
  key: string;
  displayName: string;
  value: string;
}

export function formatDateForDisplay(dateString: string | Date | undefined): string {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
}

export function resolveFieldDisplayName(
  fieldName: string,
  allFields: CpsField[] | undefined,
  contentTypeData: MainDocContentTypeResponse | undefined
): string {
  const fieldTranslation = allFields?.find(field => field.name === fieldName)?.displayName;
  if (fieldTranslation) {
    return fieldTranslation;
  }

  const contentTypeField = contentTypeData?.fields?.find(field => field.name === fieldName);
  if (contentTypeField?.name) {
    return contentTypeField.name;
  }

  return fieldName;
}

export function getDisplayableMetadata(
  metadata: CpsDocumentMetadata | undefined,
  allFields: CpsField[] | undefined,
  contentTypeData: MainDocContentTypeResponse | undefined
): DisplayableMetadataEntry[] {
  if (!metadata) {
    return [];
  }

  return Object.entries(metadata)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => ({
      key,
      displayName: resolveFieldDisplayName(key, allFields, contentTypeData),
      value: String(value)
    }));
}

export function buildDocumentVersionDownloadUrl(
  apiUrl: string,
  contentType: string,
  documentId: string,
  version: DocumentVersionResponse,
  indexId: number | undefined
): string | undefined {
  if (!version.versionId || indexId == null) {
    return undefined;
  }

  return `${apiUrl}/${buildDocumentVersionEndpointPath(contentType, documentId, version.versionId, indexId, false)}`;
}
